export const renderedText = (text: string) => {
  const lines = text.split('\n');
  let inList = false;
  let listItems: React.ReactNode[] = [];
  const paragraphLines: string[] = [];
  const result: React.ReactNode[] = [];
  let paraKey = 0;

  const flushParagraph = () => {
    if (paragraphLines.length > 0) {
      result.push(
        <p key={`p-${paraKey++}`} className="lll-type-body-large">
          {paragraphLines.join(' ')}
        </p>,
      );
      paragraphLines.length = 0;
    }
  };

  lines.forEach((line, index) => {
    if (line.trim().startsWith('- ')) {
      if (!inList) {
        flushParagraph();
        inList = true;
        listItems = [];
      }
      listItems.push(<li key={index}>{line.substring(2)}</li>);
    } else {
      if (inList) {
        inList = false;
        result.push(<ul key={`ul-${index}`}>{listItems}</ul>);
      }
      if (!line.trim()) {
        flushParagraph();
      } else {
        paragraphLines.push(line.trim());
      }
    }
  });

  if (inList) {
    result.push(<ul key="ul-end">{listItems}</ul>);
  } else {
    flushParagraph();
  }

  return result;
};
